/* eslint react/prop-types: 0 */

import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { editDataAction } from "../config/redux/action";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Navbar,
  NavbarToggler,
  Nav,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
} from "reactstrap";
import { Icon } from "semantic-ui-react";
import Firebase from "../config/firebase";
import { toast } from "react-toastify";

export const NavbarMain = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.main.dataUser);
  const [modal, setModal] = useState(false);
  const [modalProfile, setModalProfile] = useState(false);
  const [changeMyPasswordData, setChangeMyPasswordData] = useState({});
  const dataUser = JSON.parse(localStorage.getItem("user"));
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  const [phone, setPhone] = useState(user.phone);

  const toggle = () => setModal(!modal);
  const toggleProfile = () => setModalProfile(!modalProfile);

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleChange = (event) => {
    setChangeMyPasswordData({
      ...changeMyPasswordData,
      [event.target.name]: event.target.value,
    });
  };

  const changeMyPassword = (e) => {
    e.preventDefault();
    const data = { ...changeMyPasswordData };
    if (data.newPassword !== data.newPasswordConfirm) {
      toast.error("Konfirmasi Password tidak sama");
      return;
    }
    const param = {
      body: data,
      title: "Password",
      path: "user/change-my-password",
    };
    dispatch(editDataAction(param)).then((res) => {
      if (res.status === 200) {
        toggle();
        handleLogout();
      }
    });
  };

  const updateProfile = (e) => {
    e.preventDefault();
    const param = {
      body: { email, phone, name },
      title: "Update Profile",
      path: "user/me",
    };
    dispatch(editDataAction(param)).then((response) => {
      toggleProfile();
      handleLogout();
      // logout here
    });
  }

  return (
    <>
      <Navbar color="white" className="shadow-sm" style={{ zIndex: "1" }} light>
        <NavbarToggler
          onClick={props.toggle}
          className="mr-2 text-white border-0"
        />
        <label className="my-auto">
          {user.role < 4 ? (
            <p className="font-weight-bold text-dark">BUMD JAWA BARAT</p>
          ) : (
            <p className="font-weight-bold text-dark">{user.perusahaan.nama}</p>
          )}
        </label>

        <Nav className="ml-auto text-white">
          <br />
          <UncontrolledDropdown nav style={{ background: "#37C2F0", color: "#ffffff", borderRadius: '8px' }}>
            <DropdownToggle
              href="#"
              nav
              style={{ color: "#ffffff" }}
              onClick={(e) => e.preventDefault()}
            >
              <Icon name="user circle" size="large" />
              {dataUser.name} &nbsp;
              <Icon name="angle down" size="large" />
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem onClick={toggle}>
                <Icon className="m-auto" name="setting" /> &nbsp;Ubah Password
              </DropdownItem>
              <DropdownItem onClick={toggleProfile}>
                <Icon className="m-auto" name="user" /> &nbsp;Profile
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={handleLogout}>
                <Icon className="m-auto" name="sign-out" /> &nbsp;Keluar
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </Navbar >
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Ubah Password</ModalHeader>
        <ModalBody>
          <Form onSubmit="changeMyPassword">
            <div className="container">
              <Input
                onChange={handleChange}
                className="mb-3"
                type="password"
                name="oldPassword"
                placeholder="Password Saat ini"
                required
              />
              <Input
                onChange={handleChange}
                className="mb-3"
                type="password"
                name="newPassword"
                placeholder="Password Baru"
                required
              />
              <Input
                onChange={handleChange}
                className="mb-3"
                type="password"
                name="newPasswordConfirm"
                placeholder="Konfirmasi Password Baru"
                required
              />
            </div>
            <Button
              color="primary"
              onClick={changeMyPassword}
              className="mt-4"
              block
            >
              Ubah Password
            </Button>{" "}
            <Button color="secondary" onClick={toggle} block>
              Cancel
            </Button>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalProfile} toggle={toggleProfile}>
        <ModalHeader toggle={toggleProfile}>Ubah Profile</ModalHeader>
        <ModalBody>
          <Form onSubmit="changeMyPassword">
            <div className="container">
              <Input
                className="mb-3"
                type="text"
                name="name"
                placeholder="Nama"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <Input
                className="mb-3"
                type="email"
                name="email"
                placeholder="Email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Input
                className="mb-3"
                type="number"
                name="phone"
                placeholder="Telepon"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <Button
              color="primary"
              className="mt-4"
              block
              onClick={updateProfile}
            >
              Ubah Profile
            </Button>{" "}
            <Button color="secondary" onClick={toggleProfile} block>
              Cancel
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
